import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import Datagrid from '../../ui/Datagrid';
import { masterColumn } from './table_config';
import { Grid, TablePagination } from '@mui/material';
import PropTypes from 'prop-types';
import { REDUX_ACTIONS } from '../../../shared/config/constants';
import { listFieldPicturesDrill } from '../../../store/actions/fieldPicturesDrill';
import PhotoMap from '../../map/photomap';

// eslint-disable-next-line react/prop-types
function CustomPagination({ currentPage, limit, totalCount, handlePagination, loading }) {
  return (
    <TablePagination
      component="div"
      count={totalCount}
      page={currentPage}
      onPageChange={(event, page) => !loading && handlePagination(page)}
      rowsPerPage={limit}
      rowsPerPageOptions={[]}
    />
  );
}

const FieldPicturesDrill = () => {
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const fieldPicturesDrill = useSelector((state) => state.fieldPicturesDrill);
  const [filter, setFilter] = useState([]);

  const handlePagination = (page) => {
    if (page < fieldPicturesDrill.currentPage) {
      dispatch(listFieldPicturesDrill({ page: fieldPicturesDrill.currentPage - 1 }));
      dispatch({
        type: REDUX_ACTIONS.FIELD_PICTURES_DRILL_SET_CURRENT_PAGE,
        payload: fieldPicturesDrill.currentPage - 1
      });
    } else {
      dispatch(listFieldPicturesDrill({ page: fieldPicturesDrill.currentPage + 1 }));
      dispatch({
        type: REDUX_ACTIONS.FIELD_PICTURES_DRILL_SET_CURRENT_PAGE,
        payload: page + 1
      });
    }
    apiRef.current.setFilterModel({
      items: filter
    });
    apiRef.current.scrollToIndexes({
      rowIndex: 0,
      colIndex: 0,
    });
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
      <PhotoMap
        mapData={fieldPicturesDrill.marker_data}
        type='Drill'
      />
      </Grid>
      <Grid item xs={12}>
        <Datagrid
          apiRef={apiRef}
          data={fieldPicturesDrill.data}
          columns={masterColumn()}
          loading={fieldPicturesDrill.loading}
          getRowId={(row) => row.grid_id}
          sx={{
            '.MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold !important',
            },
            '.MuiDataGrid-cell': {
              fontSize: 'medium',
              fontWeight: 'bold !important',
              padding: '8px 16px'
            },
          }}
          toolbar={{
            options: {
              columns: true,
              filters: true,
              export: false,
            },
          }}
          autoPageSize={false}
          autoHeight={false}
          pagination={false}
          hideFooter
          experimentalFeatures={{ newEditingApi: true }}
          filterMode="server"
          onFilterModelChange={ (model) => {
            setFilter(model.items);
            const items = model.items.map(filter => {
              return filter;
            });
            const filterModels = { ...model, items };
            dispatch({
              type: REDUX_ACTIONS.FIELD_PICTURES_DRILL_SET_FILTER,
              payload: filterModels.items.length ? filterModels : {}
            });
          }}
          sortingMode="server"
          onSortModelChange={(sortModel) => {
            const sort = sortModel.reduce((result, item) => {
              result[item.field] = item.sort;
              return result;
            }, {});
            dispatch({
              type: REDUX_ACTIONS.FIELD_PICTURES_DRILL_SET_SORT,
              payload: sort
            });
            dispatch({
              type: REDUX_ACTIONS.FIELD_PICTURES_DRILL_SET_CURRENT_PAGE,
              payload: 1
            });
            dispatch(listFieldPicturesDrill());
          }}
          getRowHeight={() => 'auto'}
          />
          <CustomPagination
          currentPage={fieldPicturesDrill.currentPage - 1}
          limit={fieldPicturesDrill.limit}
          totalCount={fieldPicturesDrill.totalCount}
          handlePagination={handlePagination}
          loading={fieldPicturesDrill.loading}
        />
      </Grid>
    </Grid>
  );
};

FieldPicturesDrill.propTypes = {
  row: PropTypes.object,
};

export default FieldPicturesDrill;
